<script>
    import ProjectionRow from './ProjectionRow.svelte'
    import PlaceFilter   from '../inventory/PlaceFilter.svelte'
    import Issues        from '../../shared/Issues.svelte'

    export let domain   
    export let inventory
    export let activity
    export let issues = []
    
    let filter = () => true
    

    $: places     = inventory.places()
    $: collapsed  = collapsed || places.map(p => p.id)
    $: projection = inventory.projectionGiven(activity)
    $: filtered   = inventory.placesMatching(filter)
    
    function toggleCollapseAll() {
        if(collapsed.length === places.length) {
            collapsed = []
        } else {
            collapsed = places.map(p => p.id)
        }
    }
</script>
<div>
    <h3 class="ui header">Projeções da Atividade</h3>
    <PlaceFilter {inventory} bind:filter></PlaceFilter>

    <!-- <button class="ui button" on:click={ toggleCollapseAll }>
        {#if collapsed.length === places.length}ver todos{:else}ocultar todos{/if}
    </button> -->
</div>

{#if issues.length > 0}
    <div class="ui basic segment">
        <Issues {issues}>
            Problemas:
        </Issues>
    </div>
{/if}

<table class="ui fixed padded table">
    <thead>
        <tr>
            <th class="six  wide"               > Lugar      </th>
            <th class="five wide center aligned"> Sem Uso    </th>
            <th class="five wide center aligned"> Utilizados </th>
        </tr>
    </thead>    
    <tbody>
        {#each filtered as place (place.id)}
            <ProjectionRow
                {domain}
                {activity}
                {place}
                {projection}
                bind:collapsed />
        {/each}
    </tbody>
</table>

<style>
    h3.ui.header {
        margin-top: 3em;
    }
</style>